/**
 * @file banner
 * @author
 */
// @ts-nocheck
import React, {Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import {Carousel} from 'antd';
import {recordProxy} from '../../util';
import banner from './imgs/banner.mp4';
import AuthButton from './authButton';

export default function Banner(props) {
    // const anchor = () => {
    //     recordProxy('attest', 'click', 'banner-open-auth');
    //     window.location.href = `${window.location.pathname + window.location.search}#page-attest-anchor-auth`;
    // };
    const history = useHistory();
    const onAuthJump = () => {
        recordProxy('attest-banner', 'click', 'attest-step-1');
        history.push('/attest/step/1');
    };
    /* eslint-disable */
    return (
        <Fragment>
            <div className="banner">
                <Carousel
                    className="custom-carousel-class"
                    autoplay
                >
                    <div className="carousel-item">
                        <video
                            className="item-info-video"
                            muted="muted"
                            style={{width: '100%', height: '100%'}}
                            src={banner}
                            // src={'https://anquan.baidu.com/tiemabinghe/static/media/animate1_1.dfeb169b.mp4'}
                            // playsinline
                            autoPlay="autoplay"
                            loop
                        >
                            <p>你的浏览器不支持 HTML5 视频。可点击<a href="">此链接</a>观看</p>
                        </video>

                        <div className="item-info-wrapper">
                            <p className="title">
                                企业号码认证
                            </p>
                            <p className="title-tip">
                                官方标识更权威，用户更信任
                            </p>
                            <div className="thread-tips">
                                <AuthButton {...props} type="banner-btn" name="立即申请" subName="限时免费试用14天"/>
                            </div>
                            <p className="thread-active" onClick={onAuthJump}>
                                <span>政府/非盈利机构号码免费认证通道&gt;</span>
                            </p>
                        </div>
                    </div>
                </Carousel>
            </div>
        </Fragment>
    );
}